import * as types from "../actions/types";

const initialState = {
  list: [],
  group: {},
  years: [],
  terms: [],
  weekList: [],
  filter: {},
  teacherSchedule: [],
  extract: null,
  isLoading: false,
  educationYearVariableStaff: [],
};

export default function group(state = initialState, action) {
  switch (action.type) {
    case types.YEARS_FETCH_COMPLETED:
      return {
        ...state,
        years: action.list,
        currentEdYearId: action.list[action.list.length - 2].xp_key, // в массиве ОБЫЧНО последний год = следующий
      };
    case types.WEEK_FETCH_COMPLETED:
      return {
        ...state,
        weekList: action.weekList,
        currentEdWeekId: action.currentEdWeekId,
      };
    case types.TERMS_FETCH_COMPLETED:
      return {
        ...state,
        terms: action.terms,
      };
    case types.TEACHER_SCHEDULE_FETCH_COMPLETED:
      return {
        ...state,
        teacherSchedule: action.teacherSchedule,
      };
    case types.GROUP_FETCH_COMPLETED:
      return {
        ...state,
        group: action.group,
      };
    case types.GROUP_JOURNAL_FETCH_COMPLETED:
      return {
        ...state,
        groupJournal: action.groupJournal,
      };
    case types.GROUP_LIST_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.GROUP_LIST_FETCH_COMPLETED:
      return {
        ...state,
        list: action.list,
        isLoading: false,
        filter: {
          cathedraId: action.cId,
          facultyId: action.fId,
          yearId: action.yId,
        },
      };
    case types.SET_ALL_GROUP_LIST:
      return {
        ...state,
        list: action.payload
      }
    case types.SET_GROUP_LIST_VARIABLE_STUFF:
      return {
        ...state,
        groupListVariableStaff: action.payload
      }
    case types.SET_EDUCATION_YEAR_VARIABLE_STUFF:
      return {
        ...state,
        educationYearVariableStaff: action.payload
      }
    case types.GROUP_LIST_REMOVE:
      return {
        ...initialState,
      };
    case types.SET_EXTRACT_DATA: {
      return {
        ...state,
        extract: action.payload
      };
    }
    case types.SET_GROUP_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
